import { Component } from '@angular/core';

import { TwcPopupOptions } from '@topcon/twc-angular';

/**
 * Trowser that shows the create site form dialog
 */
@Component({
    selector: 'cw-create-job-site-dialog',
    templateUrl: 'create-job-site-dialog.component.html',
    standalone: false,
})
export class CreateJobSiteDialogComponent {
    titlePopupSite = 'JOB_SITE.CREATE.TITLE';
    isClosePopupSite = false;
    popupOptions!: TwcPopupOptions | undefined;
}
